import { useTranslation } from "react-i18next";
import { coolnetData } from "@/mocks/home";

export default function CoolnetSection() {
  const { t } = useTranslation("home");

  return (
    <section className="w-full bg-surface py-12 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-1/2">
            <img
              src={coolnetData.image}
              alt="Coolnet cooling solutions"
              className="w-full h-64 md:h-80 object-cover rounded-lg"
            />
          </div>
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-magenta/10 text-magenta px-4 py-1.5 rounded-full text-sm font-semibold mb-4">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-vip-crown-line" />
              </span>
              Authorized Distributor
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-magenta mb-4 leading-snug uppercase tracking-wide">
              {t("coolnet.title")}
            </h2>
            <p className="text-sm md:text-base text-text-muted leading-relaxed mb-6 text-justify">
              {t("coolnet.description")}
            </p>
            <a
              href="https://www.coolnet.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 bg-magenta text-white font-semibold px-6 py-3 rounded-md hover:bg-magenta-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-external-link-line" />
              </span>
              {t("coolnet.button")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}